import { useState } from "react";
import axios from "axios";
import { ThumbsUp } from "lucide-react";
import { toast } from "sonner";
import { API } from "@/lib/api";
import { getClientId } from "@/lib/account";

export const VoteButton = ({ shareId, votes, voted, onChange, testId = "vote-btn" }) => {
  const [busy, setBusy] = useState(false);

  const vote = async () => {
    setBusy(true);
    try {
      const { data } = await axios.post(`${API}/shared/${shareId}/vote`, null, { headers: { "X-Client-Id": getClientId() } });
      onChange(data);
      toast.success(data.voted ? "Grazie per il voto!" : "Voto rimosso");
    } catch {
      toast.error("Impossibile registrare il voto. Riprova.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <button onClick={vote} disabled={busy} data-testid={testId} aria-pressed={voted}
      className={`inline-flex items-center gap-2 rounded-full border px-5 py-2.5 text-sm font-semibold transition-colors duration-200 disabled:opacity-50 ${voted ? "border-amber-500 bg-amber-500 text-slate-950 hover:bg-amber-400" : "border-white/15 text-slate-200 hover:border-amber-500/60 hover:text-amber-300"}`}>
      <ThumbsUp className={`w-4 h-4 ${voted ? "fill-current" : ""}`} />
      {voted ? "Ti piace" : "Mi piace"} · <span data-testid={`${testId}-count`}>{votes}</span>
    </button>
  );
};
